import { render, staticRenderFns } from "./MediaAdd.vue?vue&type=template&id=0a07d882"
import script from "./MediaAdd.vue?vue&type=script&lang=js"
export * from "./MediaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports